<section class="section-lottery-results tf-spacing-1">
  <div [ngClass]="{'tf-container': !isMobile, 'tf-containerM': isMobile}">
    <div class="row">
      <div class="col-12">
        <div class="heading-section">
          <div class="title" *ngIf="title">
            {{ title }}
          </div>
          <p *ngIf="subtitle" data-wow-delay="0.1s">
            {{ subtitle }}
          </p>
        </div>


        <div [ngClass]="{'table-lottery-results': !isMobile, 'table-lottery-resultsM': isMobile}">
          <!-- Intestazione della tabella -->
          <div class="title">
            <div *ngFor="let column of columns">
              {{ column.header }}
            </div>
          </div>

          <!-- Corpo della tabella -->
          <div *ngFor="let result of results" class="item-table">
            <div *ngFor="let column of columns">
              <ng-container [ngSwitch]="column.field">
                <!-- Numeri -->
                <ul *ngSwitchCase="'numbers'" class="number-list">
                  <li *ngFor="let number of result.numbers">
                    {{ number }}
                  </li>
                </ul>

                <!-- Voti -->
                <span *ngSwitchCase="'votes'">{{ result.votes }}</span>

                <!-- Biglietti: aggiungere qui altre voci se il component viene iniettato -->
                <ul *ngSwitchCase="'yourTicket'" class="number-list">
                  <li *ngFor="let ticket of result.yourTicket">{{ ticket }}</li>
                </ul>
                <ul *ngSwitchCase="'votedTicket'" class="number-list">
                  <li *ngFor="let ticket of result.votedTicket">{{ ticket }}</li>
                </ul>

                <div *ngSwitchCase="'ticketToVote'" class="number-list-container">
                  <ul class="number-list">
                    <li *ngFor="let ticket of result.ticketToVote">{{ ticket }}</li>
                  </ul>
                  <span *ngIf="isMobile">Voted by {{result.votesTaked ?? '0'}} players</span>
                </div>

                <!-- Altri campi aggiungere qui altre voci se il component viene iniettato -->
                <span *ngSwitchCase="'yourVotes'">{{ result.yourVotes }}</span>
                <span *ngSwitchCase="'votedVotes'">{{ result.votedVotes }}</span>
                <span *ngSwitchCase="'lottery'">{{ result.lottery }}</span>
                <span *ngSwitchCase="'winner'">{{ result.winner }}</span>
                <span *ngSwitchCase="'time'">{{ result.time }}</span>
                <span *ngSwitchCase="'votesTaked'">{{ result.votesTaked }}</span>

                <div *ngSwitchCase="'template'">
                  <button class="tf-btn" [ngClass]="{ 'style-2': isVotedFn(result.number) }"
                    [disabled]="isVotedFn(result.number)" (click)="onVoteFn(result.number, result.ticketToVote)">
                    {{ isVotedFn(result.number) ? 'Voted!' : 'Vote' }}
                  </button>
                </div>

              </ng-container>
            </div>
          </div>
        </div>

        <!-- Paginazione -->
        <ul class="wg-pagination">

          <li>
            <a href="javascript:void(0)" (click)="changePage(pagination.currentPage - 1)"
              [class.disabled]="pagination.currentPage === 1">
              <i class="icon-back"></i>
            </a>
          </li>

          <li *ngFor="let page of visiblePages" [class.active]="page === pagination.currentPage">
            <a href="javascript:void(0)" (click)="changePage(page)">{{ page }}</a>
          </li>

          <li *ngIf="visiblePages[visiblePages.length - 1] < pagination.totalPages - 1">
            <span>...</span>
          </li>
          <li *ngIf="visiblePages[visiblePages.length - 1] < pagination.totalPages">
            <a href="javascript:void(0)" (click)="changePage(pagination.totalPages)">
              {{ pagination.totalPages }}
            </a>
          </li>

          <li>
            <a href="javascript:void(0)" (click)="changePage(pagination.currentPage + 1)"
              [class.disabled]="pagination.currentPage === pagination.totalPages">
              <i class="icon-next"></i>
            </a>
          </li>

        </ul>
      </div>
    </div>
  </div>
</section>